import { produce } from 'immer';
import {
  PEDIDOSLC_OBTENER_PEDIDOS_FAILURE,
  PEDIDOSLC_OBTENER_PEDIDOS_SUCCESS, PEDIDOSLC_REALIZAR_PEDIDO_FAILURE, PEDIDOSLC_REALIZAR_PEDIDO_SUCCESS,
} from '../actions/constants/pedidoslc.constants';

const initialState = {
  detallesPedidos: [],
  totalDetallesPedidos: [],
  errorPedido: null,
};

export default produce((draft = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case PEDIDOSLC_OBTENER_PEDIDOS_SUCCESS: {
      const {
        datos, total,
      } = payload;
      draft.detallesPedidos = datos;
      draft.totalDetallesPedidos = total;
      return draft;
    }
    case PEDIDOSLC_REALIZAR_PEDIDO_SUCCESS: {
      draft.errorPedido = null;
      return draft;
    }
    case PEDIDOSLC_REALIZAR_PEDIDO_FAILURE: {
      draft.errorPedido = payload;
      return draft;
    }
    default:
      return draft;
  }
});
